import { Entities_Player_ProgressSummary_Response } from '@suntex.fim/api-client';

import { usePlayerContext } from '../context';

/**
 * Hook to access the player's progress summary.
 * This is a convenience hook for components that only need the progress summary data.
 */
export function usePlayerProgressSummary(): Entities_Player_ProgressSummary_Response {
  const { progressSummary } = usePlayerContext();
  return progressSummary;
}
